const BENEFIT_TIERS = {
    NON_BI: 'non_bi',
    BI: 'bi',
    VIB: 'vib',
    ROUGE: 'rouge'
};

const BENEFIT_SECTION_TYPES = {
    FEATURED_BENEFITS: 'featuredBenefits',
    NEXT_TIER: 'nextTier'
};

const CARDHOLDER_STATUSES = {
    CARDHOLDER: 'cardholder',
    NON_CARDHOLDER: 'nonCardholder'
};

const COUNTRIES = {
    US: 'US',
    CA: 'CA'
};

const BENEFITS_DESTINATION = '/beauty/beauty-insider';
const FAQS_DESTINATION = '/beauty/beauty-insider#faqs';

export {
    BENEFIT_TIERS, BENEFIT_SECTION_TYPES, CARDHOLDER_STATUSES, COUNTRIES, BENEFITS_DESTINATION, FAQS_DESTINATION
};
